import TransportWebHID from '@ledgerhq/hw-transport-webhid'
import {
    Address,
    AggregateTransaction,
    Convert,
    Deadline,
    KeyPair,
    NetworkCurrencies,
    NetworkType,
    PlainMessage,
    PublicAccount,
    Transaction,
    TransferTransaction,
    UInt64,
} from 'symbol-sdk'
import { ApduPackage, AppVersion, LedgerDerivationPath, LedgerNetworkType, SymbolLedger } from './symbol-ledger-typescript'

/*
start of presentation logic
*/

async function restApi(endpoint: string, payload: String | null = null) {
    const nodes = [
        "https://sym-main-01.opening-line.jp:3001"
    ]
    const rgw = nodes[Math.floor(nodes.length * Math.random())]
    const req = {
        method: 'POST',
        headers: {
            'content-type': 'application/json;charset=UTF-8',
        },
        body: JSON.stringify(payload)
    }

    let res
    if (payload !== null) {
        res = await fetch(rgw + endpoint, req)
    } else {
        res = await fetch(rgw + endpoint)
    }

    return await res.json()
}


const login_button = document.getElementById("login") as HTMLInputElement
const status_label = document.getElementById("stat")
const accountListLogIn = document.getElementById("accountListLogIn") as HTMLInputElement
const accountListCancel = document.getElementById("accountListCancel")
const listmodal = document.getElementById("accountList")
const listmodalbody = document.getElementById("accountListBody")


let accounts: Array<String> = []

login_button?.addEventListener('click', async (e: Event) => {
    listmodal?.classList.add(`is-active`)
    if (accounts.length > 0) return

    accountListLogIn.disabled = true

    accounts = await getAccounts()
    
    accountListLogIn.disabled = false
    
    if (listmodalbody) listmodalbody.innerHTML = ""
    accounts.forEach(element => {
        const opt = document.createElement('option')
        opt.innerText = element as string
        listmodalbody?.appendChild(opt)
        listmodalbody?.parentElement?.classList.remove('is-loading')
    })
})

accountListLogIn?.addEventListener('click', async (e: Event) => {
/*
    Promise.all([
        restApi(`/accounts/${accounts[0]}`),
        restApi(`/accounts/${accounts[1]}`),
        restApi(`/accounts/${accounts[2]}`),
        restApi(`/accounts/${accounts[3]}`),
        restApi(`/accounts/${accounts[4]}`)
    ]).then((res) => {
        console.log(res)
    })
    */
    accountListLogIn?.classList.remove('is-active')

    const listmodalbody = document.getElementById("accountListBody") as HTMLSelectElement;
    login(listmodalbody.selectedIndex);
})

accountListCancel?.addEventListener('click', async (e: Event) => {
    const listmodal = document.getElementById("accountList")
    listmodal?.classList.remove('is-active')
})


/*
end of presentation logic
*/

async function getAccounts(accounts = 5): Promise<Array<String>> {
    const res = Array<String>()
    await TransportWebHID.create(5000, 5000).then(async transport => {
        const ledger = new SymbolLedger(transport, 'XYM')
        try {
            const ledgerNetworkType = LedgerNetworkType.TEST_NET
            const networkType = ledgerNetworkType as number as NetworkType
            for (const accountIndex of Array.from(Array(accounts).keys())) {
                const path = LedgerDerivationPath.getPath(ledgerNetworkType, 0, 0, accountIndex)
                const publicKey = await ledger.getAccount(path, ledgerNetworkType, false, false, false)
                console.log(`${path}: ${Address.createFromPublicKey(publicKey, networkType).plain()}`)

                res.push(Address.createFromPublicKey(publicKey, networkType).plain())
            }
        }catch(e){
            listmodal?.classList.remove(`is-active`)
            if (login_button) login_button.style.visibility = 'true'
            if(status_label) status_label.innerText = "Make sure that the Symbol app is running."
        } finally {
            await ledger?.close()
        }
    })
    return res
}

async function login(selectedIndex:number) {
    const deadline = Deadline.createFromDTO('1000')
    //const generationHash = '3B5E1FA6445653C971A50687E75E6D09FB30481055E3990C84B25E9222DC1155'//main net
    const generationHash = '7FCCD304802016BEBBCD342A332F91FF1F3BB5E902988B352697BE245F48E836'//Test net

    async function createTransferTransaction(ledgerNetworkType: LedgerNetworkType, networkType: NetworkType) {
        const recipientPublicKey = '41A27D66F16AA1CD07CAB6905392DCCB34FBDFB8CA3047E0CB06F32806F0E45F'
        const maxFee = UInt64.fromUint(0)
        return TransferTransaction.create(
            deadline,
            Address.createFromPublicKey(recipientPublicKey, networkType),
            [],
            PlainMessage.create('Log in'),
            networkType,
            maxFee,
        )
    }

    const verifySignature = (publicKey: string, data: string, signature: string): boolean => {
        return KeyPair.verify(Convert.hexToUint8(publicKey), Convert.hexToUint8(data), Convert.hexToUint8(signature))
    }

    const ledgerNetworkType = LedgerNetworkType.TEST_NET
    const networkType = ledgerNetworkType as number as NetworkType
    const generationHashBytes = Array.from(Convert.hexToUint8(generationHash))
    const transferTransaction = await createTransferTransaction(ledgerNetworkType, networkType)
    const payloadBytes = Array.from(Convert.hexToUint8(transferTransaction.serialize()))
    const signingBytes = transferTransaction.getSigningBytes(payloadBytes, generationHashBytes)
    
    TransportWebHID.create(5000, 5000).then(async transport => {
        const ledger = new SymbolLedger(transport, 'XYM')

        if (login_button) login_button.style.visibility = 'hidden'
        const listmodal = document.getElementById("accountList")
        listmodal?.classList.remove('is-active')
        if(status_label) status_label.innerText = "Approve transaction on Ledger"

        try {
            const path = LedgerDerivationPath.getPath(ledgerNetworkType, 0, 0, selectedIndex)
            const publicKey = await ledger.getAccount(path, ledgerNetworkType, false, false, false)
            const { signature } = await ledger.signTransaction(path, transferTransaction, generationHash, publicKey, false)

            if (verifySignature(publicKey, Convert.uint8ToHex(signingBytes), signature) === true) {
                if(status_label) status_label.innerText = "Logged in with " + Address.createFromPublicKey(publicKey, networkType).plain()
            } else {
                if(status_label) status_label.innerText = "Login failed."
            }
            
        } finally {
            await ledger?.close()
        }
    })
}